// The product brand in one place: name, parent company, domain, logos.
// Server functions have the same values in supabase/functions/_shared/brand.ts.
// Stripe objects are named carduzo_* (see supabase/functions/_shared/brand.ts STRIPE_NAMES).

export const BRAND = {
  name: 'Carduzo',
  parent: 'Santivo',
  parentLine: 'A Santivo company',
  tagline: 'The card that brings leads back.',
  domain: 'carduzo.com',
  appUrl: 'https://carduzo.com',
  logo: {
    lockup: '/brand/carduzo-logo.svg', // color mark + navy word, light backgrounds
    lockupOnDark: '/brand/carduzo-logo-on-dark.svg', // color mark + white word
    lockupWhite: '/brand/carduzo-logo-white.svg', // all white
    mark: '/brand/carduzo-mark.svg',
    markWhite: '/brand/carduzo-mark-white.svg',
    wordmarkWhite: '/brand/carduzo-wordmark-white.svg',
  },
};

/** "Ana López · Carduzo" style page titles. */
export const brandTitle = (title) => (title ? `${title} · ${BRAND.name}` : BRAND.name);
